import React from "react";
import PropTypes from "prop-types";
import { Select } from "antd";
import moment, { isMoment } from "moment";
// import { generateMonthDates } from "../../../utils/report";

const { Option } = Select;

export const getMaxDate = (frequency, month) => {
  let max = 30;
  if (
    (frequency === "Yearly" || frequency === "Bi-Annually") &&
    month !== undefined
  ) {
    if (month.toString() === "2") {
      max = 28;
    } else {
      let dt = moment().month(parseInt(month) - 1);
      if (isMoment(dt)) {
        max = dt.daysInMonth();
      }
    }
  }
  return max;
};

const DateOfMonth = (props) => {
  const { value, onChange, reportType, month } = props;

  return (
    <>
      <Select value={value} onChange={onChange} placeholder="Date" style={{width: 150}}>
        {new Array(getMaxDate(reportType, month)).fill(null).map((_, index) => (
          <Option value={index + 1}>{index + 1}</Option>
        ))}
      </Select>
      {props.children}
    </>
  );
};

DateOfMonth.defaultProps = {
  onChange: () => {},
};

DateOfMonth.propTypes = {
  onChange: PropTypes.func,
  reportType: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  month: PropTypes.number.isRequired,
};

export default DateOfMonth;
